<template>
  <div class="bq-product-main">
    <Jkyl v-show="code === '1'"></Jkyl>
    <Zhfw v-show="code === '2'"></Zhfw>
    <Zhlc v-show="code === '3'"></Zhlc>
    <Zhgl v-show="code === '4'"></Zhgl>
  </div>
</template>
<script>
// import setSpm from '@alife/set-spm';

import Jkyl from './Jkyl';
import Zhfw from './Zhfw';
import Zhlc from './Zhlc';
import Zhgl from './Zhgl';
export default {
  name: 'product',

  data() {
    return {
      code: this.$route.query.id || '1',
    };
  },
  beforeRouteUpdate(to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 可以访问组件实例 `this`
    const spma = 'a2o2ij';
    const spmbArr = ['14898857', '14898861', '14898865', '14898875']; // 健康医疗数据中心/智慧服务/智慧临床/智慧管理
    const index = parseInt(to.query.id) - 1;
    const spmb = spmbArr[index];
    console.log(`${spma}.${spmb}`);
    // setSpm(`${spma}.${spmb}`);

    this.code = to.query.id;
    next();
  },
  components: {
    Jkyl,
    Zhfw,
    Zhgl,
    Zhlc,
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/styles/fn.less';

.bq-product-main {
  padding-top: 80px;
}
</style>
